import { useNavigate } from "react-router-dom";
import { MessageCircleQuestion } from "lucide-react";
import { cn } from "@/lib/utils";

// Every list row carries one of these. It opens the Ask tab pre-filled with a
// plain-English question built from the row's labels — never an id.
export function AskAboutThis({
  prefill,
  className,
  label = "Ask about this",
}: {
  prefill: string;
  className?: string;
  label?: string;
}) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      aria-label={label || "Ask about this"}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/partner/research-hub/ask?q=${encodeURIComponent(prefill)}`);
      }}
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-1 font-body text-[11px] font-medium",
        "text-primary/80 hover:text-primary hover:bg-primary/5 transition-colors",
        className,
      )}
    >
      <MessageCircleQuestion className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {label}
    </button>
  );
}
